import React from "react";
import {Pagination} from "antd";
import PropTypes from 'prop-types';
import {connect} from 'react-redux'

import "./TasksTableFooter.css"

class TasksTableFooter extends React.Component {

  render() {
    const {contentUpdater, pagination: {currentPage, currentPageSize, totalElements}} = this.props;

    return (
      <footer className="table-wrapper__footer">
        <Pagination
          className="pagination"
          current={currentPage}
          defaultCurrent={1}
          onChange={contentUpdater}
          showSizeChanger onShowSizeChange={contentUpdater}
          pageSizeOptions={["10", "25", "50", "100"]}
          defaultPageSize={10}
          pageSize={currentPageSize}
          total={totalElements}
        />
      </footer>
    )
  }
}

const mapStateToProps = state => ({
  pagination: state.fetchInterventions.pagination
});

export default connect(
  mapStateToProps
)(TasksTableFooter);

TasksTableFooter.propTypes = {
  totalElements: PropTypes.number,
  contentUpdater: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/overview/table/TasksTableFooter.js